import { Box, Paper, Typography } from "@mui/material";
import Servicios from "../config/Servicios";

const ConfigFacturacion = () => {
    return(
      <Paper sx={{ p: 3, borderRadius: 3, boxShadow: "0 4px 20px rgba(0,0,0,0.06)" }}>
        <Box display="flex" justifyContent="space-between" alignItems="center" mb={3}>
          <Typography
            variant="h4"
            sx={{
              fontWeight: 600,
              letterSpacing: 0.5,
              flex: 1,
              minWidth: 0,
              fontSize: { xs: "1.25rem", sm: "1.75rem" },
              whiteSpace: { xs: "nowrap", sm: "normal" },
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            Configuración
          </Typography>
        </Box>
        <Servicios />
      </Paper>

    );
};

export default ConfigFacturacion;